import { FundStatus, TrancheVisibility } from 'further-types/fund';
import { CalendarDay } from 'further-ui/utils';
import { TrancheFormInput } from './useTrancheForm';

export enum TrancheFormSection {
  General = 'general',
  DataSnapshot = 'data-snapshot',
  SubscriptionDocumentation = 'subscription-documentation',
  FeeManagement = 'fee-management',
  BankDetails = 'bank-details',
  DailySummaryEmail = 'daily-summary-email',
  EmailCustomisation = 'email-customisation',
  FinalDeal = 'final-deal',
}

export const trancheFormSectionFields: Record<
  TrancheFormSection,
  Array<keyof TrancheFormInput>
> = {
  [TrancheFormSection.General]: [
    'firmId',
    'fundName',
    'fundStatus',
    'startDate',
    'finishDate',
    'closedDate',
    'tag',
    'isProfessionalClientsOnly',
    'trancheVisibility',
    'fundRaiseLimit',
  ],
  [TrancheFormSection.DataSnapshot]: [
    'incomeTaxRebate',
    'targetReturn',
    'targetPortfolioSize',
    'minimumDirectInvestment',
    'minimumAdvisedInvestment',
    'minimumIncludesAdviceFee',
  ],
  [TrancheFormSection.SubscriptionDocumentation]: [
    'applicationFormFile',
    'prospectusFile',
    'keyInfoFile',
    'additionalDocuments',
  ],
  [TrancheFormSection.FeeManagement]: [],
  [TrancheFormSection.BankDetails]: [
    'firmBankDetailId',
    'title',
    'customBankTransferReference',
  ],
  [TrancheFormSection.DailySummaryEmail]: [],
  [TrancheFormSection.EmailCustomisation]: [
    'whatToExpectNow',
    'additionalAttachment',
  ],
  [TrancheFormSection.FinalDeal]: [],
};

export const getTrancheOpenRequiredFields = (
  usesDealDocumentation: boolean,
): Set<keyof TrancheFormInput> =>
  new Set([
    'firmId',
    'fundName',
    'tag',
    'finishDate',
    'firmBankDetailId',
    ...(!usesDealDocumentation ? (['applicationFormFile'] as const) : []),
  ]);

export type EisTag = {
  id: string;
  name: string;
  isSyndicate: boolean;
};

export type TrancheData = {
  id: string;
  firmId: string;
  fundName: string;
  dataRoomId?: string;
  fundStatus?: FundStatus;
  startDate?: CalendarDay;
  finishDate?: CalendarDay;
  closedDate?: CalendarDay;
  tag?: string;
  isProfessionalClientsOnly?: boolean;
  trancheVisibility?: TrancheVisibility;
  fundRaiseLimit?: number;
  incomeTaxRebate?: string;
  targetReturn?: string;
  targetPortfolioSize?: string;
  minimumDirectInvestment?: string;
  minimumAdvisedInvestment?: string;
  minimumIncludesAdviceFee?: boolean;
  prospectusFile?: { name: string; path: string; preview?: string };
  keyInfoFile?: { name: string; path: string; preview?: string };
  applicationFormFile?: { name: string; path: string; preview?: string };
  additionalDocuments?: Array<{ name: string; path: string; preview: string }>;
  coreFeeTemplateId?: string;
  performanceFeeTemplateId?: string;
  firmBankDetailId?: string;
  title?: string;
  customBankTransferReference?: string;
  additionalInfo?: string;
  hasKiCertificate?: boolean;
  whatToExpectNow?: string;
  additionalAttachment?: {
    id: string;
    name: string;
    path: string;
    preview?: string;
  };
  investments?: Array<{ id: string }>;
};
